function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-reseauPrise");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-reseauPrise"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(5.600000, 10.400000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 18.8,
  height: 9.2
})), /*#__PURE__*/React.createElement("path", {
  d: "M15,0.857864376 L29.1421356,15 L15,29.1421356 L0.857864376,15 L15,0.857864376 Z M11.0606602,10.6464466 C10.865398,10.4511845 10.5488155,10.4511845 10.3535534,10.6464466 L10.3535534,10.6464466 L6,15 L10.3535534,19.3535534 L10.4228013,19.4114088 C10.6176694,19.5464049 10.8870938,19.5271197 11.0606602,19.3535534 L11.0606602,19.3535534 L11.1185156,19.2843055 C11.2535117,19.0894374 11.2342265,18.820013 11.0606602,18.6464466 L11.0606602,18.6464466 L7.41410678,15 L11.0606602,11.3535534 L11.1185156,11.2843055 C11.2535117,11.0894374 11.2342265,10.820013 11.0606602,10.6464466 Z M19.5843055,10.5885912 C19.3894374,10.4535951 19.120013,10.4728803 18.9464466,10.6464466 L18.9464466,10.6464466 L18.8885912,10.7156945 C18.7535951,10.9105626 18.7728803,11.179987 18.9464466,11.3535534 L18.9464466,11.3535534 L22.593,15 L18.9464466,18.6464466 L18.8885912,18.7156945 C18.7535951,18.9105626 18.7728803,19.179987 18.9464466,19.3535534 C19.1417088,19.5488155 19.4582912,19.5488155 19.6535534,19.3535534 L19.6535534,19.3535534 L24.0071068,15 L19.6535534,10.6464466 Z M12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 Z M15,14 C14.4477153,14 14,14.4477153 14,15 C14,15.5522847 14.4477153,16 15,16 C15.5522847,16 16,15.5522847 16,15 C16,14.4477153 15.5522847,14 15,14 Z M18,14 C17.4477153,14 17,14.4477153 17,15 C17,15.5522847 17.4477153,16 18,16 C18.5522847,16 19,15.5522847 19,15 C19,14.4477153 18.5522847,14 18,14 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ReseauPrise = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ReseauPrise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-reseauPrise.2d35868e.svg";
export { ForwardRef as ReactComponent };